import { FC } from 'react';
import { GenericLink, LoaderType, NextgenImage, useNextgenRouter, useTranslation } from '@nextgen-web-framework/all';
import type { LegalLinkProps } from './types/propsTypes';
import styles from './LegalLink.module.scss';

const LegalLink: FC<LegalLinkProps> = ({ legalLink }) => {
  const { disclaimer, link, footerImage } = legalLink || {};
  const t = useTranslation();
  const router = useNextgenRouter();
  const customizeCookieHandler = () => {
    window.utag?.gdpr?.showConsentPreferences(router.params?.locale);
  };
  return (
    <div className={styles['footer-bottom-legallink-container']} data-testid="legallink-container-test-id">
      <div className={styles['footer-legallink']} data-testid="legallink-test-id">
        <span className={styles['copyright']} data-testid="legallink-disclaimer-test-id">
          {disclaimer}
        </span>
        <div className={styles['legal-link-container']}>
          {link &&
            link.map((data) => (
              <div className={styles['button-container']} key={data.text}>
                <GenericLink
                  key={data?.text}
                  href={data?.url}
                  target={data.target}
                  forceNative={data?.url.includes('.xml')}
                  className={styles['legal-link-section']}
                >
                  <span className={styles['legal-link']} data-testid="link-test-id">
                    {data.text}
                  </span>
                  <span className={styles['legal-link-separators']}>{'|'}</span>
                </GenericLink>
              </div>
            ))}
          <div
            className={styles['button-container']}
            role="link"
            onClick={customizeCookieHandler}
            tabIndex={0}
            onKeyDown={customizeCookieHandler}
            aria-label="footer link"
          >
            <span className={styles['legal-link']}>{t('web.footer.cookies')}</span>
          </div>
        </div>
      </div>
      <div className={styles['legal-icon-container']} data-testid="legal-icon-container-id">
        {footerImage &&
          footerImage.map((legalLinkIcon) => (
            <div className={styles['legal-icon-image']} key={legalLinkIcon.url}>
              <GenericLink
                key={`${legalLinkIcon.url}`}
                href={legalLinkIcon.link.url}
                target={legalLinkIcon.link.target}
              >
                <NextgenImage
                  loaderType={LoaderType.CONTENTSTACK}
                  key={`${legalLinkIcon.url}`}
                  src={legalLinkIcon.url}
                  alt={legalLinkIcon.alt}
                />
              </GenericLink>
            </div>
          ))}
      </div>
    </div>
  );
};

export default LegalLink;
